export default [
    'HUF',
    'EUR',
    'USD',
    'GBP',
    'CHF',
    'CZK',
    'PLN',
    'HRK',
    'SEK',
    'DKK',
    'CAD',
    'JPY',
    'ILS',
    'ISK',
    'RON',
    'NOK',
    'RSD',
    'RUB',
    'AUD',
    'BGN',
    'UAH',
    'CNY',
    'TRY',
    'ZAR'
]